if(document.querySelector('.homepage__hero .glide')) {
  new Glide('.homepage__hero .glide').mount();
}


document.querySelectorAll('.homepage__hero .glide__slide h1').forEach(function(el) {
  el.innerHTML = el.children[0].innerHTML;
});
